export default __webpack_public_path__ + "static/eitClimate-Kic-cce24a47ff1de9ff0663849555739711.svg";